var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Countries, Version } from "../../data";
import { Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import { isEmpty, isNil } from "ramda";
import { WebSocketMessage } from "../../serverConnection";
function TabContainer(props) {
    return (React.createElement(Typography, { component: "div", style: { padding: 8 * 3 } }, props.children));
}
var DeviceList = /** @class */ (function (_super) {
    __extends(DeviceList, _super);
    function DeviceList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: 0,
            addressFilter: "",
            locationFilter: "",
            serialFilter: "",
            hostFilter: "",
            stateFilter: "",
        };
        _this.toggleValidate = function (device) {
            _this.props.send(WebSocketMessage("devices", "update", { id: device.id, validated: !device.validated }));
        };
        _this.handleChange = function (_, value) {
            _this.setState({ value: value });
        };
        _this.displayStatus = _this.displayStatus.bind(_this);
        return _this;
    }
    DeviceList.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        var devices = function (eligableCountries) {
            return _this.props.devices
                .filter(function (device) {
                if (!isEmpty(_this.state.stateFilter) && _this.state.stateFilter !== _this.getDeviceState(device)) {
                    return false;
                }
                if (!isEmpty(_this.state.addressFilter) &&
                    !device.address.toLocaleLowerCase().includes(_this.state.addressFilter)) {
                    return false;
                }
                if (!isEmpty(_this.state.serialFilter) &&
                    !device.id.toLocaleLowerCase().includes(_this.state.serialFilter)) {
                    return false;
                }
                if (!isEmpty(_this.state.hostFilter) &&
                    !device.host.toLocaleLowerCase().includes(_this.state.hostFilter)) {
                    return false;
                }
                if (!isEmpty(_this.state.locationFilter) &&
                    !device.location.toLocaleLowerCase().includes(_this.state.locationFilter)) {
                    return false;
                }
                return eligableCountries.includes(device.country) || isNil(device.country);
            })
                .map(function (device) { return (React.createElement(TableRow, { key: device.id },
                React.createElement(TableCell, null, _this.displayStatus(device.lastSeen, device.validated)),
                React.createElement(TableCell, null, moment
                    .utc(device.lastSeen)
                    .local()
                    .format("YY-MM-DD HH:mm:ss")),
                React.createElement(TableCell, null, device.id),
                React.createElement(TableCell, null, device.host),
                React.createElement(TableCell, null, device.address),
                React.createElement(TableCell, null, device.location),
                React.createElement(TableCell, null, device.version ? Version.toString(device.version) : "---"),
                React.createElement(TableCell, null,
                    React.createElement(Tooltip, { title: "Edit metadata" },
                        React.createElement(Link, { to: "/devices/" + device.id },
                            React.createElement(Icon, null, "edit")))),
                React.createElement(TableCell, null,
                    !device.validated && (React.createElement(Tooltip, { title: "Validate device" },
                        React.createElement(IconButton, { onClick: function () { return _this.toggleValidate(device); }, disabled: device.validated },
                            React.createElement(Icon, { style: { color: "green" } }, "check")))),
                    device.validated && (React.createElement(Tooltip, { title: "Invalidate device" },
                        React.createElement(IconButton, { onClick: function () { return _this.toggleValidate(device); }, disabled: !device.validated },
                            React.createElement(Icon, { style: { color: "red" } }, "clear"))))))); });
        };
        return (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col s12 m12 l12" },
                React.createElement("h5", null, "Devices"),
                React.createElement("br", null),
                React.createElement(Tabs, { value: value, onChange: this.handleChange, className: "white z-depth-1" },
                    React.createElement(Tab, { label: "All" }),
                    React.createElement(Tab, { label: "Germany" }),
                    React.createElement(Tab, { label: "Bahamas" }),
                    React.createElement(Tab, { label: "South Africa" })),
                React.createElement("br", null),
                React.createElement("div", { className: "white z-depth-1" },
                    React.createElement(TabContainer, null,
                        React.createElement(Table, null,
                            React.createElement(TableHead, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableCell, null, "Status"),
                                    React.createElement(TableCell, null, "Updated"),
                                    React.createElement(TableCell, null, "Serial No."),
                                    React.createElement(TableCell, null, "Host"),
                                    React.createElement(TableCell, null, "Address"),
                                    React.createElement(TableCell, null, "Location"),
                                    React.createElement(TableCell, null, "Version"),
                                    React.createElement(TableCell, null),
                                    React.createElement(TableCell, null),
                                    React.createElement(TableCell, null))),
                            React.createElement(TableBody, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableCell, null,
                                        React.createElement("select", { onChange: function (e) { return _this.setState({ stateFilter: e.target.value }); }, className: "select", style: {
                                                height: "1.5rem",
                                                display: "inherit",
                                                fontSize: "80%",
                                                minWidth: 80,
                                            } },
                                            React.createElement("option", { value: "" }, "All"),
                                            React.createElement("option", { value: "online" }, "Online"),
                                            React.createElement("option", { value: "offline" }, "Offline"),
                                            React.createElement("option", { value: "invalidated" }, "Not validated yet"))),
                                    React.createElement(TableCell, null),
                                    React.createElement(TableCell, null,
                                        React.createElement("input", { style: { height: "1rem", minHeight: "1rem", margin: 0 }, value: this.state.serialFilter, onChange: function (e) {
                                                return _this.setState({ serialFilter: e.target.value.toLocaleLowerCase() });
                                            } })),
                                    React.createElement(TableCell, null,
                                        React.createElement("input", { style: { height: "1rem", minHeight: "1rem", margin: 0 }, value: this.state.hostFilter, onChange: function (e) {
                                                return _this.setState({ hostFilter: e.target.value.toLocaleLowerCase() });
                                            } })),
                                    React.createElement(TableCell, null,
                                        React.createElement("input", { style: { height: "1rem", minHeight: "1rem", margin: 0 }, value: this.state.addressFilter, onChange: function (e) {
                                                return _this.setState({ addressFilter: e.target.value.toLocaleLowerCase() });
                                            } })),
                                    React.createElement(TableCell, null,
                                        React.createElement("input", { style: { height: "1rem", minHeight: "1rem", margin: 0 }, value: this.state.locationFilter, onChange: function (e) {
                                                return _this.setState({
                                                    locationFilter: e.target.value.toLocaleLowerCase(),
                                                });
                                            } })),
                                    React.createElement(TableCell, null),
                                    React.createElement(TableCell, null),
                                    React.createElement(TableCell, null)),
                                devices(value === 0 ? __spreadArrays(Countries) : [Countries[value - 1]]))))))));
    };
    DeviceList.prototype.getDeviceState = function (device) {
        var difference = moment().diff(moment(device.lastSeen), "minutes");
        if (!device.validated) {
            return "invalidated";
        }
        if (difference <= 10) {
            return "online";
        }
        else {
            return "offline";
        }
    };
    DeviceList.prototype.displayStatus = function (deviceStatus, validated) {
        var difference = moment().diff(moment(deviceStatus), "minutes");
        if (!validated) {
            return (deviceStatus = React.createElement(Icon, { className: "yellow-text" }, "fiber_manual_record"));
        }
        if (difference <= 10) {
            return (deviceStatus = React.createElement(Icon, { className: "green-text" }, "fiber_manual_record"));
        }
        else {
            return (deviceStatus = React.createElement(Icon, { className: "red-text" }, "fiber_manual_record"));
        }
    };
    return DeviceList;
}(Component));
export default DeviceList;



//////////////////
// WEBPACK FOOTER
// ./src/components/devices/DeviceList.tsx
// module id = 1273
// module chunks = 0